import React from "react";
export function Footer() {
  return <footer className="bg-navy-900 px-4 pb-32 pt-12 text-center text-white/60 sm:px-6" data-id="element-141" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-3xl" data-id="element-142" data-mp="3ggtymjf7hl5r">
        <p className="font-serif text-xl font-bold text-white" data-id="element-143" data-mp="32nulup6t651w">Facelift Blueprint™</p>
        <p className="mt-1 text-sm" data-id="element-144" data-mp="32m1bayt2r0om">A structured educational resource created by Dr. Michael Carter.</p>
        <p className="mt-6 text-xs" data-id="element-145" data-mp="36n3axgqwler4">© 2026 Dr. Michael Carter. All rights reserved.</p>
        <div className="mt-6 space-y-3 text-xs leading-relaxed" data-id="element-146" data-mp="3ucxndx7b91au">
          <p data-id="element-147" data-mp="37ft3219eq1n">
            Facelift Blueprint™ is intended for educational use by qualified healthcare professionals. It is not a substitute for formal
            surgical education, supervised training, clinical guidelines, institutional protocols, individualized patient assessment,
            or professional clinical judgment.
          </p>
          <p data-id="element-148" data-mp="2a1ji55nwno0v">
            Surgical techniques, indications, and outcomes vary according to the individual patient and clinical context. Healthcare
            professionals are responsible for using current evidence, appropriate training, and professional judgment when making
            clinical decisions.
          </p>
          <p data-id="element-149" data-mp="3v89dics1lrft">Educational cases and examples should not be interpreted as patient-specific medical advice or validated operative protocols.</p>
        </div>
      </div>
    </footer>;
}